function heroParallax(scene) {

	// let scene = document.querySelector(".ev-main__hero-test>.ev-hero__layers");
	console.log(scene.offsetHeight);


	const childList = [...scene.children];
	const firstDash = childList.findIndex(div => div.className.includes('ev-hero__dashboard-'));
	const children = childList.map((div, i) => {
		const cls = div.className;
		let xMul, yMul, xBase, yBase, xOff = 0, yOff = 0, xWobble = 0, yWobble = 0, wobbleMs = 5_000;

		if (cls.includes('ev-hero__dashboard-')) {
			const i2 = i - firstDash - 1;
			console.log(i2);
			xMul = 0.01 + i2 * 0.02;
			yMul = 0.01 + i2 * 0.03;
			xBase = 0.4;
			yBase = 0.9;
			if (i2 > 0) yOff = 50; // px
			xWobble = 0.7;
			wobbleMs = Math.random() * 7_000 + 5_000;
		}
		else if (cls.includes('ev-hero__gateway-')) {
			const i2 = i - firstDash - 1;
			console.log(i2);
			xMul = -0.01 + i2 * -0.02;
			yMul = -0.01 + i2 * -0.03;
			xBase = 0.1;
			yBase = 0.9;
			// if (i2 > 0) yOff = 50; // px
			yWobble = 0.3;
			xWobble = 0.3;
			wobbleMs = Math.random() * 7_000 + 5_000;
		}
		else {
			xMul = -0.01 - i * 0.01;
			yMul = -0.01 - i * 0.01;
			xBase = 0.66;
			yBase = 0.5;
			yWobble = 0.5;
			wobbleMs = Math.random() * 3_000 + 2_000;
		}
		return { div, xMul, yMul, xBase, yBase, xOff, yOff, xWobble, yWobble, wobbleMs };
	});
	console.log(children);

	let width = window.innerWidth, height = scene.offsetHeight;
	let mouseX = 0, mouseY = 0, curX = width / 2, curY = height / 2;

	let lastT = Date.now();

	const animate = () => {

		window.requestAnimationFrame(animate);

		const t = Date.now();
		const ms = Math.max(1, Math.min(100, t - lastT));

		let moveX = (mouseX - curX) / 2;
		let moveY = (mouseY + document.documentElement.scrollTop - curY) / 2;
		curX += Math.sign(moveX) * Math.min(width * 0.5, Math.abs(moveX)) * (ms / 300);
		curY += Math.sign(moveY) * Math.min(width * 0.5, Math.abs(moveY)) * (ms / 300);

		lastT = t;


		const viewX = curX / width;
		const viewY = curY / height;

		for (const { div, xMul, yMul, xBase, yBase, xOff, yOff, xWobble, yWobble, wobbleMs } of children) {

			const wobble = Math.sin(t / wobbleMs);

			let xTr = (viewX + xWobble * wobble) - xBase;
			let yTr = (viewY + yWobble * wobble) - yBase;

			// xTr = Math.pow(Math.abs(xTr), 0.5) * Math.sign(xTr);
			// yTr = Math.pow(Math.abs(yTr), 0.5) * Math.sign(yTr);

			const x = width * xTr * xMul + xOff;
			const y = height * yTr * yMul + yOff;

			// console.log(x, y);

			div.style.transform = `translate(${x}px, ${y}px)`;

		}

	}
	animate();


	document.addEventListener('mousemove', e => {
		// console.log(e.sourceCapabilities.firesTouchEvents);
		mouseX = e.clientX;
		mouseY = e.clientY;
		// console.log(viewX.toFixed(3), viewY.toFixed(3));
	});

	document.addEventListener('resize', () => {
		width = window.innerWidth;
		height = scene.offsetHeight;
	});


}

document.querySelectorAll('.ev-main__hero-test>.ev-hero__layers, .ev-hero__double>.ev-hero__layers').forEach(heroParallax);
